// Type definitions for distribution rate objects
interface DistributionRate {
    week: string;
    actualDistributionRate: number;
}

interface NewDistributionRate {
    week: string;
    actualDistributionRate?: number;
}

interface ChangedDistributionRate {
    week: string;
    actualDistributionRate: number;
}

export const hasRateChanged = (oldValue: number, newValue: number, oldHasOverride: boolean, newHasOverride: boolean): boolean => {
    if (isNaN(oldValue) || isNaN(newValue)) return false;
    return oldValue !== newValue || oldHasOverride !== newHasOverride;
};

export const getChangedWeeklyDistributionRates = (
    newRates: NewDistributionRate[], 
    oldRates: DistributionRate[]
): ChangedDistributionRate[] => {
    const changes: ChangedDistributionRate[] = [];
    
    for (const newRate of newRates) {
        const oldRate = oldRates.find(rate => rate.week === newRate.week);
        if (oldRate) {
            const oldValue: number = oldRate.actualDistributionRate;
            const newValue: number = newRate.actualDistributionRate ?? 0;
            const oldHasOverride = (oldRate as any).hasDistributionRateOverride || false;
            const newHasOverride = (newRate as any).hasDistributionRateOverride || false;

            if (hasRateChanged(oldValue, newValue, oldHasOverride, newHasOverride)) {
                changes.push({ week: newRate.week, actualDistributionRate: newValue });
            }
        }
    }
    
    return changes;
};

export const isFieldPast = (field: string, allowPastWeeks = false): boolean => {
    if (allowPastWeeks) return false;

    const [day, month, year] = field.split('-').map(Number);
    const columnDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return columnDate <= today;
}; 